import useSWR from 'swr';
import request from './request';

/*
  Axios call methods
*/

export const getDreGrouping = async (companyId) => {
  return request({
    url: `DreGroupings/Company/${companyId}`,
    method: 'GET',
  });
};

export const getDreGroupingItem = async (id) => {
  return request({
    url: `DreGroupings/${id}`,
    method: 'GET',
  });
};

export const putDreGroupingItem = async (dreGroup) => {
  return request({
    url: `DreGroupings/${dreGroup.id}`,
    method: 'PUT',
    data: dreGroup,
  });
};

export const postDreGroupingItem = async (dreGroup) => {
  return request({
    url: `DreGroupings/`,
    method: 'POST',
    data: dreGroup,
  });
};
export const deleteDreGroupingItem = async (dreGroup) => {
  return request({
    url: `DreGroupings/${dreGroup}`,
    method: 'DELETE',
  });
};

/*
  useQuery - SWR methods
*/

export const useQueryDreGrouping = (companyId, options) => {
  const key = companyId ? `dreGrouping-${companyId}` : null;
  const { data, error } = useSWR(
    () => key,
    companyId ? () => getDreGrouping(companyId) : null,
    options ?? null
  );

  return {
    data,
    isLoading: !error && !data,
    isError: error,
  };
};

export const useQueryDreGroupingItem = (id, options) => {
  const key = 'dreGroupingItem';
  const { data, error } = useSWR(
    () => key,
    id ? () => getDreGroupingItem(id) : null,
    options ?? null
  );

  return {
    data,
    isLoading: !error && !data,
    isError: error,
  };
};
